import React from 'react';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';
import { InputLabelContainer } from '../../../../common/components/form/label/containers/input-label.container';

export const DbnpMappingBasicInfoComponent = ({ id,onFormChange, dbnp, selectedDbnpMapping, fetchDbnpList }: any) => {
   
    return (<>
 <AccordionContainer
     child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
       
         {id !== '0' &&
         <div>
            <InputLabelContainer label=" Global ProviderDBNP Name" />
            <InputLabelContainer label={selectedDbnpMapping?.GlobalProviderDBNPName} />
            </div>}

<InputContainer
isDisabled
    label="Map Consumer Enabled"
    name="IsDBNPConsumerEnabled"
    onValueChange={(event: any) => {
      onFormChange(
        event,
        'IsDBNPConsumerEnabled'
      )
    }}
    type="checkbox"
    value={selectedDbnpMapping?.IsDBNPConsumerEnabled}
/>

<InputContainer
isDisabled
              label="Map Provider Enabled"
              name="ISDBNPProviderEnabled"
              onValueChange={(event: any) => {
                onFormChange(
                  event,
                  'ISDBNPProviderEnabled'
                )
              }}
              type="checkbox"
              value={selectedDbnpMapping?.ISDBNPProviderEnabled}
          />

     <InputContainer
     isDisabled
              label="Map Vendor Role Enabled"
              name="IsDBNPVendorRoleEnabled"
              onValueChange={(event: any) => {
                onFormChange(
                  event,
                  'IsDBNPVendorRoleEnabled'
                )
              }}
              type="checkbox"
              value={selectedDbnpMapping?.IsDBNPVendorRoleEnabled}
          />
   <InputContainer
   isDisabled
              label="Map Supplier Role Enabled"
              name="IsDBNPSupplierRoleEnabled"
              onValueChange={(event: any) => {
                onFormChange(
                  event,
                  'IsDBNPSupplierRoleEnabled'
                )
              }}
              type="checkbox"
              value={selectedDbnpMapping?.IsDBNPSupplierRoleEnabled}
          />
      <InputContainer
      isDisabled
               label="Map Partner Role Enabled"
               name="IsDBNPPartnerRoleEnabled"
               onValueChange={(event: any) => {
                 onFormChange(
                   event,
                   'IsDBNPPartnerRoleEnabled'
                 )
               }}
               type="checkbox"
               value={selectedDbnpMapping?.IsDBNPPartnerRoleEnabled}
           />
</div>

          }
     expandedPanel="basicInfo"
     headerTitle="Basic Info"
 />
        </>
)}
export default DbnpMappingBasicInfoComponent;
